import React from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { useLocale } from 'client/i18n/hooks/useLocale';
import { SupportedLocales } from 'client/i18n/types';
import { localizedQuotesMap } from './LocalizedQuotes';
import {
  SwitchPageQuotesContainer,
  SwitchQuotesTitle,
  SwitchQuotesColumns,
} from './styles';

// There are localized quotes for only some markets at the moment, but this list might grow in the future.
const marketsWithLocalizedQuotes: SupportedLocales[] = ['es-LA', 'id', 'pt-BR'];

export function SwitchQuotesSection() {
  const t = useT();
  const { locale } = useLocale();

  const Quotes = (marketsWithLocalizedQuotes.includes(locale)
    ? localizedQuotesMap[locale]
    : localizedQuotesMap.en) as React.ElementType;

  return (
    <SwitchPageQuotesContainer>
      <SwitchQuotesTitle>
        {t(
          'ImportScreen.SwitchQuotesSection.Title',
          'Discover what creators love most about Anchor',
          'Switch to Anchor page podcasters experiences section title'
        )}
      </SwitchQuotesTitle>
      <SwitchQuotesColumns>
        <Quotes />
      </SwitchQuotesColumns>
    </SwitchPageQuotesContainer>
  );
}
